/* Flipper Kids — Focal collection card image swipe/drag carousel
   Added by Claude (Anthropic AI) 2026-09-03
   Touch swipe (mobile) + mouse drag (desktop) to cycle through all product images
   on collection/grid product cards. No arrow buttons, no dots — matches the live
   theme's fk-card-carousel-v5 behavior (swipe/drag only). */
(function () {
  var SWIPE_THRESHOLD = 15;
  var cache = {};

  function getHandle(href) {
    if (!href) return null;
    var clean = href.split('?')[0].split('#')[0];
    var m = clean.match(/\/products\/([^\/]+)\/?$/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function sized(src, w) {
    if (!src) return src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + w + 'x$1$3');
  }

  function build(link, p) {
    var images = (p.images || []).slice();
    if (images.length < 2) return;
    if (link.dataset.fkCarousel) return;
    link.dataset.fkCarousel = '1';
    link.classList.add('fk-car-wrap');
    /* IMPORTANT: links (and images) are natively draggable in the browser by default.
       A real mouse drag on an <a> can be captured as a native link/image drag-and-drop
       gesture (dragstart/dragend) instead of firing our mousemove/mouseup handlers.
       Explicitly disable that so our custom drag logic receives the events. */
    link.setAttribute('draggable', 'false');

    var idx = 0;
    var n = images.length;

    images.forEach(function (s) { var im = new Image(); im.src = sized(s, 600); });

    var overlay = document.createElement('img');
    overlay.className = 'fk-car-overlay';
    overlay.alt = '';
    overlay.draggable = false;
    overlay.style.display = 'none';
    link.appendChild(overlay);

    function show(i) {
      idx = (i + n) % n;
      if (idx === 0) {
        overlay.style.display = 'none';
      } else {
        overlay.src = sized(images[idx], 600);
        overlay.style.display = 'block';
      }
    }

    /* --- Touch swipe (mobile) --- */
    /* 2026-10-21 (Claude): inside a horizontal scroller (homepage "featured collections", recommendations,
       recently viewed, cart recommendations) the horizontal swipe belongs to the carousel, so image swiping
       is disabled there. It stays active in collection/search grids, where the page only scrolls vertically. */
    var inHorizontalCarousel = !!link.closest('.scroller, [data-fk-no-swipe]');
    var sx = null, sy = null, swiped = false;
    if (!inHorizontalCarousel) link.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false;
    }, { passive: true });
    if (!inHorizontalCarousel) link.addEventListener('touchmove', function (e) {
      if (sx === null) return;
      var dx = e.touches[0].clientX - sx;
      var dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > 5 && Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
      }
    }, { passive: false });
    if (!inHorizontalCarousel) link.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        e.preventDefault();
        show(dx > 0 ? idx + 1 : idx - 1);
        setTimeout(function () { swiped = false; }, 400);
      }
    }, { passive: false });
    link.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* --- Mouse drag (desktop) --- */
    var mx = null, dragged = false;
    link.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      mx = e.clientX; dragged = false;
      e.preventDefault();
    });
    link.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    link.addEventListener('mousemove', function (e) {
      if (mx === null) return;
      if (Math.abs(e.clientX - mx) > 5) {
        dragged = true;
        link.style.cursor = 'grabbing';
      }
    });
    link.addEventListener('mouseup', function (e) {
      if (mx === null) return;
      var ddx = e.clientX - mx;
      mx = null;
      link.style.cursor = '';
      if (Math.abs(ddx) > SWIPE_THRESHOLD) {
        dragged = true;
        show(ddx > 0 ? idx + 1 : idx - 1);
        setTimeout(function () { dragged = false; }, 400);
      } else {
        dragged = false;
      }
    });
    link.addEventListener('mouseleave', function () {
      mx = null; link.style.cursor = '';
    });
    link.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    link.style.cursor = 'grab';
  }

  function scan() {
    var links = document.querySelectorAll('.product-item__aspect-ratio');
    for (var i = 0; i < links.length; i++) {
      (function (a) {
        if (a.dataset.fkCarousel) return;
        var handle = getHandle(a.getAttribute('href') || '');
        if (!handle) return;
        fetchProduct(handle).then(function (p) { if (p) build(a, p); });
      })(links[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }

  var t = null;
  var mo = new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(scan, 300);
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
